import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="w-full bg-dark-navy py-16 md:py-24 px-6 md:px-12 relative overflow-hidden" data-id="element-53">
      <div className="absolute inset-0 bg-cyan-bloom opacity-30 pointer-events-none" data-id="element-54"></div>
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-55">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-56">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-57">
            <div className="space-y-4" data-id="element-58">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight text-white" data-id="element-59">
                THE BIOLOGICAL AUTO-SCAN
              </h1>
              <p className="text-xl md:text-2xl text-teal-accent font-semibold" data-id="element-60">
                The A-Z Encyclopedia of Symptoms & Their Emotional Origins
              </p>
            </div>

            <h2 className="text-lg md:text-xl text-stone-300 leading-relaxed" data-id="element-61">
              Stop treating the "smoke" and start healing the "fire." Find the
              hidden emotional trauma behind your physical pain in 60 seconds.
            </h2>

            <CTAButton data-id="element-62" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex justify-center" data-id="element-63">
            <div className="relative" data-id="element-64">
              <div className="absolute inset-0 bg-teal-accent/20 blur-3xl rounded-full cyan-glow-strong" data-id="element-65"></div>
              <img src="https://cdn.magicpatterns.com/uploads/cSKyxi8XgRzaDkPWuLbY5s/Picture.png" alt="The Biological Auto-Scan Book Cover" className="relative w-full max-w-md rounded-lg shadow-2xl" data-id="element-66" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}